import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { SinalizationService } from '@services/sinalization.service';
import { Store, select } from '@ngrx/store';
import { AppState } from '@store/state/app.state';
import { GetSinalization } from '@store/actions/user.action';
import { MessageService } from '@services/message.service';
import { Router } from '@angular/router';
import { getMaturity } from '@store/selectors/config.selector';
import { take, finalize } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-fast-quote',
    templateUrl: './fast-quote.component.html',
    styleUrls: ['./fast-quote.component.scss'],
    standalone: false
})
export class FastQuoteComponent implements OnInit {

  maturityValues = [];
  percentageValues = [5, 10, 15, 20, 25, 30, 35, 40,
    45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100];

  row2 = false;
  row3 = false;
  row4 = false;
  row5 = false;

  fastQuoteForm: UntypedFormGroup;
  sent = false;
  // True while the request is running: avoids sending the signalization more than once
  pending = false;

  constructor(private formBuilder: UntypedFormBuilder,
              private sinalizationService: SinalizationService,
              private messageService: MessageService,
              private router: Router,
              public store: Store<AppState>,
              private readonly translateService: TranslateService) { }

  ngOnInit() {
    this.store.pipe(
      select(getMaturity),
      take(1)
    ).subscribe(maturities => this.maturityValues = maturities.map(maturity => maturity.maturity));

    this.fastQuoteForm = this.formBuilder.group({
      maturity: '',
      value: '',
      maturity2: '',
      value2: '',
      maturity3: '',
      value3: '',
      maturity4: '',
      value4: '',
      maturity5: '',
      value5: ''
    } ,
    { validators: [this.fastQuoteFormValidator()] });
  }

  get f() { return this.fastQuoteForm.controls; }

  onSubmit() {
    if (this.fastQuoteForm.invalid) {
        return;
    }
    this.sent = true;
  }

  confirm(): void {
    if (this.pending) {
      return;
    }

    let args: any;

    args = { mns: 'fastQuoteOTC',
        mtv: this.fastQuoteForm.value.value, mmt: this.fastQuoteForm.value.maturity, mcv: 'fastQuoteOTC' };

    if (this.fastQuoteForm.value.value2 !== '') {
      args = { mns: 'fastQuoteOTC',
      mtv: this.fastQuoteForm.value.value2, mmt: this.fastQuoteForm.value.maturity2, mcv: 'fastQuoteOTC' };
    }

    if (this.fastQuoteForm.value.value3 !== '') {
      args = { mns: 'fastQuoteOTC',
      mtv: this.fastQuoteForm.value.value3, mmt: this.fastQuoteForm.value.maturity3, mcv: 'fastQuoteOTC' };
    }

    if (this.fastQuoteForm.value.value4 !== '') {
      args = { mns: 'fastQuoteOTC',
      mtv: this.fastQuoteForm.value.value4, mmt: this.fastQuoteForm.value.maturity4, mcv: 'fastQuoteOTC' };
    }

    if (this.fastQuoteForm.value.value5 !== '') {
      args = { mns: 'fastQuoteOTC',
      mtv: this.fastQuoteForm.value.value5, mmt: this.fastQuoteForm.value.maturity5, mcv: 'fastQuoteOTC' };
    }

    this.pending = true;
    this.sinalizationService.createSinalization(args).pipe(
      finalize(() => this.pending = false)
    ).subscribe((response) => {
      if (response.status === 200 && response.success) {
        this.store.dispatch(new GetSinalization());
        this.messageService.show(this.translateService.instant('edp.emarket.fast.quote.sinalizacao.enviada'));
        this.router.navigate(['/signalings']);
      } else {
        this.messageService.show(this.translateService.instant('edp.emarket.fast.quote.erro.enviar'), 'error');
      }
    });

  }

  addRow() {
    if (!this.row2) {
      this.row2 = true;
      return;
    }
    if (!this.row3) {
      this.row3 = true;
      return;
    }
    if (!this.row4) {
      this.row4 = true;
      return;
    }
    if (!this.row5) {
      this.row5 = true;
    }
  }

  deleteRow(deletedRow) {
    switch (deletedRow) {
      case 2:
        this.row2 = false;
        break;
      case 3:
        this.row3 = false;
        break;
      case 4:
        this.row4 = false;
        break;
      case 5:
        this.row5 = false;
        break;
    }
  }

  organizeRows(deletedRow) {
    if (deletedRow === 5) {
      this.fastQuoteForm.controls.maturity5.setValue('');
      this.fastQuoteForm.controls.value5.setValue('');
    }

    if (deletedRow <= 2) {
      if (this.fastQuoteForm.controls.maturity3.value === '' && this.fastQuoteForm.controls.value3.value === '') {
        this.row2 = false;
      }
      if (this.fastQuoteForm.controls.maturity3.value !== '') {
        this.fastQuoteForm.controls.maturity2.setValue(this.fastQuoteForm.controls.maturity3.value);
      }
      if (this.fastQuoteForm.controls.value3.value !== '') {
        this.fastQuoteForm.controls.value2.setValue(this.fastQuoteForm.controls.value3.value);
      }
      this.fastQuoteForm.controls.maturity3.setValue('');
      this.fastQuoteForm.controls.value3.setValue('');
    }

    if (deletedRow <= 3) {
      if (this.fastQuoteForm.controls.maturity4.value !== '') {
        this.fastQuoteForm.controls.maturity3.setValue(this.fastQuoteForm.controls.maturity4.value);
      }
      if (this.fastQuoteForm.controls.value4.value !== '') {
        this.fastQuoteForm.controls.value3.setValue(this.fastQuoteForm.controls.value4.value);
      }
      this.fastQuoteForm.controls.maturity4.setValue('');
      this.fastQuoteForm.controls.value4.setValue('');
    }

    if (deletedRow <= 4) {
      if (this.fastQuoteForm.controls.maturity5.value !== '') {
        this.fastQuoteForm.controls.maturity4.setValue(this.fastQuoteForm.controls.maturity5.value);
      }
      if (this.fastQuoteForm.controls.value5.value !== '') {
        this.fastQuoteForm.controls.value4.setValue(this.fastQuoteForm.controls.value5.value);
      }
      this.fastQuoteForm.controls.maturity5.setValue('');
      this.fastQuoteForm.controls.value5.setValue('');
    }

    this.deleteRow(deletedRow);
  }

  removeRow2() {
    this.fastQuoteForm.controls.maturity2.setValue('');
    this.fastQuoteForm.controls.value2.setValue('');
    this.organizeRows(2);
  }

  removeRow3() {
    this.fastQuoteForm.controls.maturity3.setValue('');
    this.fastQuoteForm.controls.value3.setValue('');
    this.organizeRows(3);
  }

  removeRow4() {
    this.fastQuoteForm.controls.maturity4.setValue('');
    this.fastQuoteForm.controls.value4.setValue('');
    this.organizeRows(4);
  }

  removeRow5() {
    this.fastQuoteForm.controls.maturity5.setValue('');
    this.fastQuoteForm.controls.value5.setValue('');
    this.organizeRows(5);
  }

  fastQuoteFormValidator(): ValidatorFn {
    return (ctrl: AbstractControl): ValidationErrors | null => {
      const fg = ctrl as UntypedFormGroup;
      const controls = Object.values(fg.controls);
      let fulfilled = false;

      for (let i = 0; i < 9; i += 2) {
        if ((controls[i].value === '' && controls[i + 1].value !== '') ||
        (controls[i].value !== '' && controls[i + 1].value === '')) {
          return {failed: true};
        }

        if (controls[i].value !== '' && controls[i + 1].value !== '') {
          fulfilled = true;
        }
      }
      return fulfilled ? null : {failed: true};
    };
  }
}



